export default __webpack_public_path__ + "static/media/comoros.4a298c10.svg";